import React from 'react'

import Heros from './sections/Heros'
import Team from './sections/Team'
import AboutUs from './sections/AboutUs'

const Home = () => {
    return(
        <React.Fragment>
            <Heros/>
            <Team/>
            <AboutUs/>
        </React.Fragment>
    )
}

export default Home